export default __webpack_public_path__ + "static/media/whats.23ba589a.png";